import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_MULTI_FOR_MULTI_UPDATE_MUTATION = graphql(/* GraphQL */ `
	mutation discountMultiForMultiUpdate($input: DiscountMultiInput!) {
		discountMultiUpdate(input: $input) {
			userErrors
		}
	}
`);
